
import CompanyToggle from '@/components/buttons/dedicated/CompanyToggle.vue';
import ActionDialog from '@/components/dialog/ActionDialog.vue';
import EmployeeAvatar from '@/components/employee/EmployeeAvatar.vue';
import Checkbox from '@/components/inputs/Checkbox.vue';
import SlidePanel from '@/components/interface/SlidePanel.vue';
import NavSection from '@/components/nav/common/NavSection.vue';
import { fullName } from '@/lib/employee/employeeFunctions';
import { Icon } from '@/lib/enum/Icon';
import { clockInViaPortalsAtLocationFilter } from '@/lib/location/locationFilters';
import { isVisibleRoute, NavItemInterface } from '@/lib/navigation/helpers';
import { navItems } from '@/lib/navigation/navItems';
import { Entity } from '@/lib/realtime/RealtimeEntity';
import { realtimeQuery } from '@/lib/realtime/weak/realtimeFunctions';
import { redirect } from '@/router/router';
import { routes } from '@/router/routes';
import store from '@/store';
import { PropType } from 'vue';
import { Company, Employee, Location } from '../../../api/v1';

export default {
  name: 'UserNav',
  components: {
    NavSection,
    Checkbox,
    ActionDialog,
    EmployeeAvatar,
    CompanyToggle,
    SlidePanel,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    useBackgroundOverlay: {
      type: Boolean,
      default: false,
    },
    showEmployeeHeader: {
      type: Boolean,
      default: false,
    },
    showUnsectionedItems: {
      type: Boolean,
      default: false,
    },
    showTimeOffItems: {
      type: Boolean,
      default: false,
    },
    showProfileItems: {
      type: Boolean,
      default: false,
    },
    showDeveloperSettings: {
      type: Boolean,
      default: false,
    },
    extraItems: {
      type: Array as PropType<NavItemInterface[]>,
      default: () => [],
    },
  },
  data() {
    return {
      navItems,
      Icon,
      routes,
      logoutPrompt: {
        show: false,
        everywhere: false,
      },
      clockingProfiles: realtimeQuery(Entity.EmployeeClockingProfile)
        .where('employeeId', 'eq', store.getters.loggedInEmployee.id)
        .fetch(),
    };
  },
  computed: {
    currentCompany: (): Company => store.getters.currentCompany,
    loggedInEmployee: (): Employee | null => store.getters.loggedInEmployee,
    locationsWithClockingViaPortals: (): Location[] =>
      store.getters['locations/locationsWithClockInViaPortalEnabled'],

    unsectionedItems(): NavItemInterface[] {
      return this.loggedInEmployee
        ? [
            navItems.employmentDetails(this.loggedInEmployee.id),
            navItems.whereAndWhen(this.loggedInEmployee.id),
            navItems.personalDetails(this.loggedInEmployee.id),
            navItems.myDocuments(this.loggedInEmployee.id),
            navItems.wageAndSalary(this.loggedInEmployee.id),
            navItems.emergencyDetails(this.loggedInEmployee.id),
          ].filter(isVisibleRoute(true, this.currentCompany))
        : [];
    },

    timeOffItems(): NavItemInterface[] {
      return this.loggedInEmployee
        ? [
            navItems.unavailability(this.loggedInEmployee.id),
            navItems.leave(this.loggedInEmployee.id),
            navItems.absence(this.loggedInEmployee.id),
          ].filter(isVisibleRoute(true, this.currentCompany))
        : [];
    },

    profileItems(): NavItemInterface[] {
      return this.loggedInEmployee
        ? [
            ...(!this.showUnsectionedItems
              ? [navItems.myProfile(this.loggedInEmployee.id)]
              : []),
            navItems.accountDetails(),
            navItems.updatePassword(),
            navItems.notificationPreferences(),
            ...(this.clockingProfiles.data[0]?.clockInPin
              ? [
                  navItems.clockingProfile(
                    this.loggedInEmployee,
                    this.locationsWithClockingViaPortals.some(
                      clockInViaPortalsAtLocationFilter(this.loggedInEmployee),
                    ),
                  ),
                ]
              : []),
            ...(this.showDeveloperSettings
              ? [navItems.developerSettings()]
              : []),
            navItems.referAFriend(),
            ...this.extraItems,
            navItems.logout(() => {
              this.logoutPrompt.show = true;
            }),
          ].filter(isVisibleRoute(true, this.currentCompany))
        : [];
    },
  },
  methods: {
    fullName,
    redirect,

    onClick(item: NavItemInterface) {
      if (item.enabled) {
        if (item.to) {
          redirect(item.to);
        } else {
          item.action();
        }
        this.$emit('input', false);
      }
    },
  },
};
